import { IMapCenterZoomBounds, TMapBounds } from '../../../Map/types/mapBounds';
import { parseQuery, parseUrl, stringifyQuery } from '../queryString/queryString';

export function queryStringWithMapBounds(queryString: string, mapBounds: IMapCenterZoomBounds): string {
  const query = parseQuery(queryString);

  query['center'] = mapBounds.center.join(',');
  query['zoom'] = mapBounds.zoom;

  return stringifyQuery(query);
}

export function isCenterZoomBounds(bounds: Partial<TMapBounds>): bounds is IMapCenterZoomBounds {
  return isValidCenter(bounds.center || []) && typeof bounds.zoom === 'number';
}

export function mapBoundsFromUrl(url: string): IMapCenterZoomBounds | null {
  const { center: centerRaw, zoom } = parseUrl(url).query;
  if (typeof centerRaw === 'string' && typeof zoom === 'number') {
    const center = centerRaw
      .split(',')
      .map(part =>
        !Number.isNaN(Number(part)) && typeof part === 'string' && part.trim() !== '' ? Number(part) : null,
      );

    if (!isValidCenter(center)) {
      return null;
    }

    if (zoom < 0 || zoom > 23) {
      return null;
    }

    return {
      center,
      zoom,
    };
  }

  return null;
}

function isValidCenter(value: (number | null)[]): value is YMaps.TCoord {
  if (value.length !== 2) {
    return false;
  }

  const [lat, lng] = value;

  return lat !== null && lng !== null && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}
